<div class="layout-sidebar"
     [ngClass]="{
        '_expanded': isExpanded,
        '_collapsed': isCollapsed
      }">
  <div class="layout-menu-container">
    <app-menu *ngIf="!isLoading"></app-menu>
  </div>
</div>
